/**
 * Galerie produit : image principale + vignettes + flèches.
 */
function initProductGallery() {
    const root = document.querySelector('[data-product-gallery]');
    if (!root) {
        return;
    }

    const raw = root.dataset.galleryImages;
    if (!raw) {
        return;
    }

    let images;
    try {
        images = JSON.parse(raw);
    } catch {
        return;
    }

    if (!Array.isArray(images) || images.length < 2) {
        return;
    }

    const main = root.querySelector('[data-product-gallery-main]');
    const prev = root.querySelector('[data-product-gallery-prev]');
    const next = root.querySelector('[data-product-gallery-next]');
    const thumbs = root.querySelectorAll('[data-product-gallery-thumb]');

    if (!main) {
        return;
    }

    let index = 0;

    const setIndex = (nextIndex) => {
        const max = images.length - 1;
        if (nextIndex < 0) {
            index = max;
        } else if (nextIndex > max) {
            index = 0;
        } else {
            index = nextIndex;
        }

        root.dataset.galleryIndex = String(index);

        const item = images[index];
        const url = item && item.url ? item.url : '';
        const id = item && item.id ? item.id : 0;

        if (url) {
            const img = document.createElement('img');
            img.className = 'product-landing__main-img';
            img.src = url;
            img.alt = '';
            img.loading = 'lazy';
            img.decoding = 'async';
            main.replaceChildren(img);
        }

        thumbs.forEach((btn, i) => {
            const active = i === index;
            btn.classList.toggle('is-active', active);
            btn.setAttribute('aria-current', active ? 'true' : 'false');
        });
    };

    prev?.addEventListener('click', () => setIndex(index - 1));
    next?.addEventListener('click', () => setIndex(index + 1));

    thumbs.forEach((btn) => {
        btn.addEventListener('click', () => {
            const i = parseInt(btn.dataset.galleryIndex || '0', 10);
            if (!Number.isNaN(i)) {
                setIndex(i);
            }
        });
    });
}

function initProductQuantitySteppers() {
    document.querySelectorAll('.product-landing__quantity').forEach((wrap) => {
        const input = wrap.querySelector('input.qty');
        const minus = wrap.querySelector('[data-qty-minus]');
        const plus = wrap.querySelector('[data-qty-plus]');

        if (!input || !minus || !plus) {
            return;
        }

        const step = () => {
            const s = parseFloat(input.getAttribute('step') || '1');
            return Number.isFinite(s) && s > 0 ? s : 1;
        };

        const min = () => {
            const m = parseFloat(input.getAttribute('min') || '1');
            return Number.isFinite(m) && m >= 0 ? m : 1;
        };

        const max = () => {
            const m = parseFloat(input.getAttribute('max') || '');
            return Number.isFinite(m) && m > 0 ? m : Infinity;
        };

        const setVal = (n) => {
            const lo = min();
            const hi = max();
            let v = Math.min(hi, Math.max(lo, n));
            const st = step();
            v = Math.round((v - lo) / st) * st + lo;
            v = Math.min(hi, Math.max(lo, v));
            input.value = String(v);
            input.dispatchEvent(new Event('change', { bubbles: true }));
        };

        const readVal = () => {
            const v = parseFloat(input.value);
            return Number.isFinite(v) ? v : min();
        };

        minus.addEventListener('click', () => {
            setVal(readVal() - step());
        });

        plus.addEventListener('click', () => {
            setVal(readVal() + step());
        });
    });
}

function initProductPage() {
    initProductGallery();
    initProductQuantitySteppers();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductPage);
} else {
    initProductPage();
}
